export default __webpack_public_path__ + "img/unchecked-black.6979253f.svg";